if (!customElements.get('faq-page')) {
  customElements.define(
    'faq-page',
    class FAQPage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.nav = this.querySelector('.faq-page__nav');
        this.groupHeadings = this.querySelectorAll('.faq-group__heading');

        const faqGroupIDS = Array.from(this.groupHeadings).map((ele) => ele.id);

        const spans = [];
        faqGroupIDS.forEach((id, i) => {
          const span = document.createElement('div');
          span.innerHTML = i == 0? `<a href="#${id}" class="faq-nav__item cta active">${id}</a>` : `<a href="#${id}" class="faq-nav__item cta">${id}</a>`;
          spans.push(span);
        })
        this.nav.append(...spans);

        this.nav.classList.add('active');

        this.navItems = this.querySelectorAll('.faq-nav__item');
        this.handleNavClick = this.handleNavClick.bind(this);

        this.groupHeadings.forEach((ele) => ele.addEventListener('click', this.handleHeadingClick));
        this.navItems.forEach((ele) => ele.addEventListener('click', this.handleNavClick));
      }

      handleHeadingClick(event) {
        window.location.hash = event.currentTarget.id;
      }

      handleNavClick(event) {
        this.navItems.forEach((ele) => ele.classList.remove('active'));
        event.currentTarget.classList.add('active');
      }
    }
  );
}
